import React, { useImperativeHandle, useRef, useState } from "react";
import { RCCHookToast, RCCRefModalProps, RCCServicesApi} from "react-common-components";
import { useForm } from "react-hook-form";
import ModalTreeHierarchyMaps from "src/components/ModalTreeHierarchyMaps";
import { useTranslation } from "src/context/Translations/context";
import { MapsHierarchyTypes } from "src/pages/StrategicPlanning/Maps/interface";
import { standardErrorMessages } from "src/utils/errors";

import { IModalCopyIniciatives, IRefIniciativeCopyModals, TypeIniciative} from "../interface";


const ModalCopyIniciative: React.ForwardRefRenderFunction<IRefIniciativeCopyModals, IModalCopyIniciatives> = ({
	subtitle,
	onCallbackCopyIniciative
}, ref) => {
	const { translate, currentLanguage } = useTranslation(); 
	const { addToast } = RCCHookToast();
	const modalCopyIniciatives = useRef<RCCRefModalProps>(null);

	const [idObjective, setIdObjective] = useState<number>();
	const [idKr, setIdKr] = useState<number>();

	const { 
		handleSubmit, 
		register,
		reset,
		unregister
	} = useForm();

	const onSubmit = async (data: any) => {
		try{
			if(Object.keys(data).length !== 0 ){
				const dataForm = Object.values(data[`selectedItens-${MapsHierarchyTypes.INICIATIVES}`]).filter((item: any) => typeof item === "string");
			
				if(dataForm.length === 0){
					addToast({
						color: "yellow",
						description: translate("Selecione uma iniciativa para ser copiada"),
						title: translate("Atenção")
					});
					return;
				}

				await RCCServicesApi.putRequest({
					method: "Iniciative/Copy",
					body: {
						iniciatives: dataForm,
						idObjective,
						idKr,
						currentLanguage
					}
				});
			}
			modalCopyIniciatives.current?.closeModal();

			if(onCallbackCopyIniciative !== undefined)
				onCallbackCopyIniciative();
		}catch(err){
			standardErrorMessages(err, translate("Erro ao copiar iniciativas"), addToast);
			modalCopyIniciatives.current?.closeModal();
		}
	};

	const openModalCopyIniciative = async (typeIniciative: TypeIniciative) => {
		reset();
		setIdKr(typeIniciative.idKr);
		setIdObjective(typeIniciative.idObjective);
		modalCopyIniciatives.current?.openModal();
	};

	useImperativeHandle(ref, () => ({
		openModalCopyIniciative
	}));

	return (
		<ModalTreeHierarchyMaps 
			ref={modalCopyIniciatives}
			title={translate("Copiar Iniciativas")}
			subtitle={`${translate("Objetivo")}: ${subtitle}`}
			icon="copy"
			footer= {{
				showSaveButton: true,
				buttonLoadingText: translate("Carregando"),
				saveButtonText: translate("Copiar"),
				cancelButtonText: translate("Cancelar")
			}}
			onSubmit={handleSubmit(onSubmit)}
			onClose={() => {
				if(onCallbackCopyIniciative !== undefined)
					onCallbackCopyIniciative();
			}}
			register={register}
			unregister={unregister}
			checkLevelHierarchy = {MapsHierarchyTypes.INICIATIVES}
			lastLevelHierarchy={MapsHierarchyTypes.INICIATIVES} 
		/>
	);
};

export default React.forwardRef(ModalCopyIniciative);
